import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  return: string = '';
  error:string;

  constructor(public authService : AuthService ,private notificationService: NotificationService, private route: ActivatedRoute) { }

  ngOnInit() { }
  onSignin(form:NgForm){
    const email = form.value.email

      this.authService.resetPassword(email).then((d)=>{
        this.notificationService.showNotification('success',"Please check your email or spam folder.")
      }).catch(err=>{
        this.error = err;
        console.log("Reset Password",err)
      })
  }

  valid(form:NgForm){
    return !form.invalid;
  }
}
